module.exports = __webpack_public_path__ + "img/main-02-01.dd05d527.png";